module.exports = __webpack_public_path__ + "img/gdpr.0bb32f84.png";